import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Container, Col, Row } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
// import { uploadUnitHolder } from "../../../stores/services/unit-holder.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import xls from "xlsx";
import { Modal } from "react-bootstrap";
import { bulkUploadUnitHolderFile } from "../../stores/services/unit-holder.service";
import { env } from "../../env";
import { useSelector } from "react-redux";
import { getSalesCompanyByAMCCode } from "../../stores/services/sales.service";
import Select from "react-select";
import { unitholderCategoryType } from "../../utils/customFunction";
import moment from "moment";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";
import { getAllCompanies } from "../../stores/services/company.service";

const LegacyPastUnitholderUploader = () => {
  const arrAllHeadings = [
    "FolioNo",
    "Type",
    "PortfolioManagement",
    "TaxStatus",
    "ClientName",
    "FatherSpouse",
    "Dob",
    "Age",
    "RiskFactor",
    "Cnic",
    "CnicExpiry",
    "NTN",
    "Email",
    "Phone",
    "Mobile",
    "Address",
    "City",
    "Province",
    "AccountTitle",
    "AccountNumber",
    "Bank",
    "Branch",
    "TaxExempt",
    "ZakatExempt",
    "JointH1Name",
    "JointH1FatherSpouse",
    "JointH1Cnic",
    "JointH1TaxStatus",
    "JointH2Name",
    "JointH2FatherSpouse",
    "JointH2Cnic",
    "JointH2TaxStatus",
    "JointH3Name",
    "JointH3FatherSpouse",
    "JointH3Cnic",
    "JointH3TaxStatus",
    "CdcIas",
    "CdcSubAccount",
    "CdcParticipantId",
    "InHouseSale",
    "SalesCompany",
    "SalesPerson",
    "Reinvest",
    "GuardianName",
    "GuardianRelation",
    "GuardianCnic",
    "NomineeName",
    "NomineeRelation",
    "NomineeCnic",
  ];

  const arrEmployeeHeading = [
    "EmployeeCode",
    // "Type",
    "ClientName",
    "DOB",
    "InvestmentOption",
    "ZakatExempt",
    "InterestOnProfit",
    "JoiningDate",
    "CNIC",
    "CNICExpiry",
    "Email",
    "Mobile",
    "Phone",
    "Address",
    "City",
    "AccountTitle",
    "AccountNo",
    "BankName",
    "BranchName",
    "Nominee1Name",
    "Nominee1Relation",
    "Nominee1CNIC",
    "Nominee2Name",
    "Nominee2Relation",
    "Nominee2CNIC",
    "Nominee3Name",
    "Nominee3Relation",
    "Nominee3CNIC",
  ];

  const arrNomineeHeading = ["EmployeeCode", "Name", "Relation", "CNIC"];

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [fileData, setfileData] = useState<any>([]);
  const [fileSomeData, setfileSomeData] = useState<any>([]);
  const [remainingCount, setRemainingCount] = useState("");
  const myRef1 = useRef<HTMLInputElement>(null);
  const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
  const [fileDataCount, setFileDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorData, setErrorData] = useState<any>([]);
  const [errorShow, setErrorShow] = useState(false);
  const [modalFlag, setModalFlag] = useState(false);
  const [duplicateFolioArr, setDuplicateFolioArr] = useState<any>([]);
  const [allSalesCompany, setAllSalesCompany] = useState<any>([]);
  const [unitholderType, setUnitholderType] = useState("");
  const [megaEmployeeData, setMegaEmployeeData] = useState<any>([]);
  const [nomineeData, setNomineeData] = useState<any>([]);
  const { customStyles } = useCustomStylesDropDown();

  const [companyOptions, setCompanyOptions] = useState<any>([]);
  const [companyName, setCompanyName] = useState<any>(null);
  const [loadingCompany, setLoadingCompany] = useState<any>(false);

  const fetchAllCompanies = async () => {
    try {
      setLoadingCompany(true);
      const resp = await getAllCompanies({ email, fetch_all: "all" });

      if (resp.data.status === 200) {
        const options = resp.data.data.map((c) => ({
          value: c.company_code,
          label: `${c.name_of_company} (${c.company_code})`,
        }));

        setCompanyOptions(options);
      }
    } finally {
      setLoadingCompany(false);
    }
  };

  useEffect(() => {
    const getAllSalesCompany = async () => {
      try {
        const response = await getSalesCompanyByAMCCode(email, amc_code);
        if (response.data.status == 200) {
          setAllSalesCompany(response.data.data);
        } else {
          setAllSalesCompany([]);
        }
      } catch (error) {
        setAllSalesCompany([]);
      }
    };
    getAllSalesCompany();
    fetchAllCompanies();
  }, []);

  const UploadTxn = async () => {
    if (file) {
      setLoading(true);

      if (unitholderType === "Employee" && !companyName?.value) {
        toast.error("Please Select Company First");
        setLoading(false);
        return;
      }

      let dataEmployee: any = [];
      let errorDateFormat = "";

      if (unitholderType === "Employee") {
        dataEmployee = nomineeData?.map((ele) => {
          if (moment(ele?.DOB).format("YYYY-MM-DD") == "Invalid date") {
            errorDateFormat = "Kindly set all date to this format mm/dd/yyyy";
          }
          return {
            Type: "Employee",
            EmployeeNo: ele?.EmployeeCode,
            ClientName: ele?.ClientName,
            Dob: ele?.DOB ? moment(ele?.DOB).format("YYYY-MM-DD") : "",
            InvestmentOption: ele?.InvestmentOption || "",
            ZakatExempt: ele?.ZakatExempt || "",
            InterestOnProfit: ele?.InterestOnProfit || "",
            joining_date: ele?.JoiningDate
              ? moment(ele?.JoiningDate).format("YYYY-MM-DD")
              : "",
            FolioNo: ele?.EmployeeCode,
            Cnic: ele?.CNIC,
            CnicExpiry: ele?.CNICExpiry
              ? moment(ele?.CNICExpiry).format("YYYY-MM-DD")
              : "",
            Email: ele?.Email,
            Mobile: ele?.Mobile,
            Phone: ele?.Phone,
            Address: ele?.Address,
            City: ele?.City,
            AccountTitle: ele?.AccountTitle,
            AccountNumber: ele?.AccountNo,
            Bank: ele?.BankName,
            Branch: ele?.BranchName,
            employee_nominee: JSON.stringify(ele?.employee_nominee || "[]"),
          };
        });
      }

      if (errorDateFormat) {
        toast.error(errorDateFormat);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const res = await bulkUploadUnitHolderFile(
          email,
          amc_code || "",
          unitholderType === "Employee" ? dataEmployee : fileData,
          companyName?.value ?? "",
        );

        if (res.data.status == 200) {
          toast.success(res.data.message);
          setFile("");
          setFileName("");
          fileData.length = 0;
          setfileData(fileData);
          errorData.length = 0;
          setErrorData(errorData);
          setFileDataCount(0);
          setRemainingCount("");
          setfileSomeData(fileData);
          setUnitholderType("");
          setNomineeData([]);
        } else {
          toast.error(res.data.message);
          if (res?.data?.status === 400 && res?.data?.folios?.length > 0) {
            setModalFlag(true);
            setDuplicateFolioArr(res?.data?.folios);
          } else if (
            res?.data?.status === 400 &&
            res?.data?.duplicateFolios?.length > 0
          ) {
            setModalFlag(true);
            setDuplicateFolioArr(res?.data?.duplicateFolios);
          }
        }
      } catch (error: any) {
        setLoading(false);
        console.log(error);

        if (error.response?.data?.status == 500) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.status == 400) {
          setErrorBoolean(true);
          setErrorData(error.response.data.data);
        } else {
          toast.error(
            error.response?.data?.message ?? "An unexpected error occurred",
          );
        }
      }

      setLoading(false);
    } else {
      toast.error("Kindly Upload File");
    }
  };

  const upload = async (e: any) => {
    setFileError("");
    let file = e?.target.files[0];
    let type = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (type === "xlsx" || type === "csv") {
      fileData.length = 0;
      setfileSomeData(fileData);
      setFile(file);
      setFileName(file.name);
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target?.result;
        const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data: any = xls.utils.sheet_to_json(ws, {
          header: 2,
          raw: false,
          defval: "",
          dateNF: "YYYY-MM-DD",
        });
        /* Update state */

        // if file is empty
        if (data?.length === 0 || data === undefined) {
          toast.error("File Should not be empty");
          setfileData([]);
          setFileDataCount(0);
          setFileName("");
          return;
        }

        if (data) {
          let temp: any = [];
          let isValidUpload = true;
          let isEmptySalesCompany = true;

          const uploadedHeaders = Object?.keys(data[0])
            ?.filter((ele) => !ele?.includes("__EMPTY"))
            .map((item) => item.trim()?.toLowerCase()); // remvoving spaces for better matching
          const headersMatch = arrAllHeadings?.every((header) => {
            return uploadedHeaders.includes(header.trim()?.toLowerCase());
          });

          if (
            headersMatch === false ||
            arrAllHeadings?.length !== uploadedHeaders?.length
          ) {
            toast.error(
              "Uploaded file headers do not match the expected format.",
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          const companyMap = new Map();
          allSalesCompany?.forEach((company) => {
            companyMap?.set(company?.company_name, company);
          });

          temp = data
            ?.map((item, index) => {
              const rowNumber = index + 2;
              const inHouseSale =
                item?.InHouseSale == "TRUE"
                  ? "True"
                  : item?.InHouseSale == "FALSE"
                    ? "False"
                    : "";
              const reInvestValue =
                item?.Reinvest == "TRUE"
                  ? "True"
                  : item?.Reinvest == "FALSE"
                    ? "False"
                    : "";
              const zakatValue =
                item?.ZakatExempt == "TRUE"
                  ? "True"
                  : item?.ZakatExempt == "FALSE"
                    ? "False"
                    : "";
              let salesPersonValue = "";
              let SalesComapnyValue = "";

              let currentCompany: any = null;

              if (
                item?.SalesPerson?.trim() !== "" &&
                item?.SalesCompany?.trim() == ""
              ) {
                isEmptySalesCompany = false;
                return null;
              }

              if (
                item?.hasOwnProperty("SalesCompany") &&
                item?.SalesCompany?.trim() !== ""
              ) {
                currentCompany = companyMap?.get(item?.SalesCompany?.trim());
                if (!currentCompany) {
                  isValidUpload = false;
                  toast.error(
                    `Row ${rowNumber}: Company "${item?.SalesCompany}" is not valid.`,
                  );
                  return null;
                } else {
                  SalesComapnyValue = allSalesCompany?.find(
                    (ele: any) =>
                      ele?.company_name?.toLowerCase()?.trim() ==
                      item?.SalesCompany?.toLowerCase()?.trim(),
                  )?.company_code;
                }
              } else {
                isValidUpload = true;
                // toast.error(`Row ${rowNumber}: Missing or invalid 'SalesCompany' in row.`);
                // return null;
              }

              if (
                currentCompany &&
                item?.hasOwnProperty("SalesPerson") &&
                item?.SalesPerson?.trim() !== ""
              ) {
                const salesPersonName = item?.SalesPerson.trim();
                // console.log("person11", currentCompany)
                const personsInCompany = currentCompany?.persons || [];
                // console.log("person22", personsInCompany)
                const personExists = personsInCompany?.some(
                  (person) => person?.id === salesPersonName,
                );
                // console.log("person33", personExists)
                if (!personExists) {
                  isValidUpload = false;
                  toast.error(
                    `Row ${rowNumber}: Sales Person "${salesPersonName}" is not registered under company "${item?.SalesCompany}".`,
                  );
                  return null;
                } else {
                  salesPersonValue = personsInCompany[0]?.id;
                }
              } else {
                isValidUpload = true;
                // toast.error(`Row ${rowNumber}: Missing or invalid 'SalesPerson' in row for company "${item?.SalesCompany}".`);
                // return null;
              }
              // else if (currentCompany) {
              //     isValidUpload = false;
              //     toast.error(`Row ${rowNumber}: Missing or invalid 'SalesPerson' in row for company "${item?.SalesCompany}".`);
              //     return null;
              // }

              return {
                ...item,
                SalesCompany: SalesComapnyValue,
                SalesPerson: salesPersonValue,
                InHouseSale: inHouseSale,
                Reinvest: reInvestValue,
                ZakatExempt: zakatValue,
              };
            })
            ?.filter(Boolean);

          if (!isEmptySalesCompany) {
            toast.error(
              "Sales Company cannot be empty when a Sales Person is specified.",
            );
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          if (!isValidUpload) {
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            return;
          }

          setfileData(temp);
          // setfileData(data);
          setFileDataCount(data.length);
          if (data.length > 100) {
            const someData: any = [...data];
            someData.length = 100;
            let remainingRecords = parseFloat(data.length) - 100;
            setRemainingCount(remainingRecords.toString());
            setfileSomeData(someData);
          } else {
            // setRemainingCount(data.length.toString());
            setfileSomeData(data);
          }
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    } else {
      toast.error("Please Upload Correct Format of File");
    }
  };

  const handleEmployeeUpload = (e: any) => {
    setFileError("");
    let file = e?.target.files[0];
    let type = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (type === "xlsx" || type === "csv") {
      fileData.length = 0;
      setfileSomeData(fileData);
      setFile(file);
      setFileName(file.name);
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target?.result;
        const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data: any = xls.utils.sheet_to_json(ws, {
          header: 2,
          raw: false,
          defval: "",
          dateNF: "YYYY-MM-DD",
        });
        /* Update state */

        const errorFunc = (msg) => {
          toast.error(msg);
          setfileData([]);
          setFileDataCount(0);
          setFileName("");
          setMegaEmployeeData([]);
          setNomineeData([]);
          // return
        };

        // if file is empty
        if (data?.length === 0 || data === undefined) {
          errorFunc("Employee Sheet Should not be empty!");
          return;
        }

        // filter if there is any empty header key
        const uploadedHeadersEmployee = Object.keys(data[0])
          ?.filter((ele) => !ele?.includes("__EMPTY"))
          .map((item) => item.trim()); // remvoving spaces for better matching

        let hasDuplicate = false;
        data
          .map((ele2) => ele2?.EmployeeCode)
          ?.sort()
          ?.sort((a, b) => {
            if (a === b) hasDuplicate = true;
          });

        const headersMatch =
          arrEmployeeHeading?.length > uploadedHeadersEmployee?.length
            ? arrEmployeeHeading?.every((header) => {
                return uploadedHeadersEmployee.includes(header.trim());
              })
            : uploadedHeadersEmployee?.every((header) => {
                return arrEmployeeHeading?.includes(header?.trim());
              });
        if (
          headersMatch === false ||
          arrEmployeeHeading?.length !== uploadedHeadersEmployee?.length
        ) {
          errorFunc("Employee sheet headers do not match the expected format.");
          return;
        }

        if (hasDuplicate) {
          errorFunc("EmployeeCode should not be same");
          return;
        }

        if (data?.length > 0) {
          // filter those keys which has ___Empty
          const filteredDataEmployee = data.map((obj) => {
            return Object.fromEntries(
              Object.entries(obj).filter(([key]) => !key.startsWith("__EMPTY")),
            );
          });

          let tempArr = filteredDataEmployee?.map((ele) => {
            return {
              ...ele,
              employee_nominee: [
                {
                  nominee_name: ele?.Nominee1Name || "",
                  nominee_relation: ele?.Nominee1Relation || "",
                  nominee_cnic: ele?.Nominee1CNIC || "",
                },
                {
                  nominee_name: ele?.Nominee2Name || "",
                  nominee_relation: ele?.Nominee2Relation || "",
                  nominee_cnic: ele?.Nominee2CNIC || "",
                },
                {
                  nominee_name: ele?.Nominee3Name || "",
                  nominee_relation: ele?.Nominee3Relation || "",
                  nominee_cnic: ele?.Nominee3CNIC || "",
                },
              ].filter(
                (nominee) =>
                  nominee.nominee_name ||
                  nominee.nominee_relation ||
                  nominee.nominee_cnic,
              ),
            };
          });
          setNomineeData(tempArr);

          // setNomineeData(filteredDataNominee)
          setfileData(filteredDataEmployee);
          setFileDataCount(filteredDataEmployee.length);
          setfileSomeData(filteredDataEmployee);
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    } else {
      toast.error("Please Upload Correct Format of File");
    }
  };

  const [errorBoolean, setErrorBoolean] = useState(false);

  const renderErrorPopup = () => {
    switch (errorBoolean) {
      case true:
        return (
          <Modal
            className=" "
            dialogClassName="modal60w"
            enforceFocus={false}
            show={true}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setErrorBoolean(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">
                Kindly fill following fields data Missing Fields{" "}
              </h6>
            </div>

            <div className="modal-body">
              <div className="">
                <Row>
                  <div className={"d-flex border w-100"}>
                    <div className={"w-50"}>Row Number</div>
                    <div className={"w-50"}>Field Name</div>
                  </div>
                  {errorData.map((item, index) => {
                    return (
                      <div className={"d-flex w-100"}>
                        <div className={"w-50"}>{item.row_number}</div>
                        <div className={"w-50"}>{item.field_name}</div>
                      </div>
                    );
                  })}
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const selectedUnitholderType = React.useMemo(() => {
    return unitholderType
      ? {
          value: unitholderType,
          label: unitholderType,
        }
      : null;
  }, [unitholderType]);

  const renderUniholderType = () => {
    return unitholderCategoryType?.map((item: any) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  return (
    <>
      <div className="content">
        <Modal
          className=""
          dialogClassName="modal90w"
          show={modalFlag ? true : false}
          size="sm"
          backdrop={true}
          onHide={() => {
            setModalFlag(false);
          }}
          centered={true}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setModalFlag(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">
              {unitholderType === "Employee"
                ? "Employee Code already exist"
                : "Duplicate Folios"}
            </h6>
          </div>
          <div className="modal-body">
            <div className="p-2 border">
              <div
                style={{ maxHeight: "40vh", overflowY: "auto" }}
                className="list-group"
              >
                {duplicateFolioArr?.map((dup) => (
                  <span
                    style={{
                      background: "transparent",
                      borderTop: "none",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme == "light" ? "black" : "white",
                    }}
                    key={dup}
                    className={`list-group-item list-group-item-action`}
                  >
                    {dup}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Modal>
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="d-flex align-items-center"></div>

                <div className="">
                  <div className="card-header">
                    <h4 className="card-title">
                      {/* Unit Holders */}
                      Clients Uploader
                      <Dropdown className="float-right">
                        <Dropdown.Toggle
                          href={`${env.REACT_APP_SAMPLE_URL}Unit_Holder.xlsx`}
                          variant="dark"
                          id="dropdown-basic"
                        >
                          Download Sample
                        </Dropdown.Toggle>
                      </Dropdown>
                    </h4>
                  </div>
                  <div className="card-body">
                    {/* <div className="ml-3 mr-3"> */}
                    <div className="row">
                      <div className="col-md-4">
                        <label>Type</label>
                        <div>
                          <Select
                            value={selectedUnitholderType}
                            label={"Select Type"}
                            onChange={(e) => {
                              setUnitholderType(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderUniholderType()}
                            styles={customStyles}
                          />
                        </div>
                      </div>

                      {selectedUnitholderType?.value === "Employee" && (
                        <div className="col-md-4">
                          <label>Company Name</label>
                          <Select
                            isLoading={loadingCompany}
                            value={companyName}
                            onChange={setCompanyName}
                            isClearable
                            isSearchable
                            options={companyOptions}
                            styles={customStyles}
                          />
                        </div>
                      )}

                      <div className="col-md-4">
                        <label>Choose File</label>
                        <div onClick={() => myRef1?.current?.click()}>
                          <div className="form-group">
                            <div
                              className="form-control"
                              data-tip="Upload File"
                            >
                              {fileName === "" ? "Upload File" : fileName}
                            </div>
                            <input
                              type="file"
                              ref={myRef1}
                              style={{ display: "none" }}
                              multiple={false}
                              data-tip="Upload File"
                              onChange={(e) => {
                                if (unitholderType) {
                                  unitholderType === "Employee"
                                    ? handleEmployeeUpload(e)
                                    : upload(e);
                                } else {
                                  toast.error("Select Type first");
                                }
                              }}
                              onClick={(e) => {
                                e.currentTarget.value = "";
                              }}
                            />
                            {fileError ? (
                              <p className="error-labels error-message2">
                                {fileError}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {fileUploadingFlag && (
                          <i className="fa fa-spinner fa-spin fa-2x"></i>
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {unitholderType === "Employee" && fileData?.length > 0 && (
                      <h1 className="my-2">Employee</h1>
                    )}
                    {fileData?.length > 0 ? (
                      <div className="table-responsive">
                        <JsonToTable json={fileSomeData} />
                      </div>
                    ) : fileName ? (
                      <Row className="d-flex justify-content-center my-3">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </Row>
                    ) : null}
                    {remainingCount !== "" && (
                      <>
                        <span className="text-primary">
                          {"... " + remainingCount + " More Rows"}
                        </span>
                        <br />
                      </>
                    )}
                    Total Rows:{" "}
                    <span className="text-primary mt-3">{fileDataCount} </span>
                    <div className="">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          UploadTxn();
                        }}
                        disabled={Boolean(loading)}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Upload</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {renderErrorPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LegacyPastUnitholderUploader;
